












































import Vue from 'vue';

import { UsuarioAuth } from '../../../back/src/types';

export default Vue.extend({
  name: 'MenuLateral',
  props: {
    usuario: {
      type: Object as () => UsuarioAuth,
    },
  },
  data: () => ({
    drawer: false,
    menuDeslogado: [
      {
        icon: 'fa-sign-in-alt',
        title: 'Login',
        path: { name: 'Login' },
        exact: false,
      },
      {
        icon: 'fa-address-book',
        title: 'Cadastro de paciente',
        path: { name: 'PacientesCadastroExterno' },
        exact: false,
      },
    ],
    menuLogado: [
      {
        icon: 'fa-home',
        path: { name: 'Home' },
        title: 'Página inicial',
        exact: true,
        entidade: 'Home',
        acao: 'view',
      },
      {
        icon: 'fa-address-book',
        path: { name: 'PacientesIndex' },
        title: 'Pacientes',
        exact: false,
        entidade: 'Paciente',
        acao: 'view_index',
      },
      {
        icon: 'fa-table',
        path: { name: 'PacientesGestantesPreNatal' },
        title: 'Gestantes Pré-Natal',
        exact: true,
        entidade: 'Paciente',
        acao: 'view_gestantes',
      },
      {
        icon: 'fa-procedures',
        path: { name: 'InternacoesIndex' },
        title: 'Internações',
        exact: true,
        entidade: 'Internacao',
        acao: 'view',
      },
      {
        icon: 'fa-baby',
        path: { name: 'GestacoesNascidos' },
        title: 'Nascidos',
        exact: true,
        entidade: 'Gestacao',
        acao: 'view',
      },
      {
        icon: 'fa-users',
        path: { name: 'ConsultasColetivasIndex' },
        title: 'Consultas coletivas',
        exact: false,
        entidade: 'ConsultaColetiva',
        acao: 'view',
      },
      {
        icon: 'fa-user',
        path: { name: 'UsuariosIndex' },
        title: 'Usuários',
        exact: false,
        entidade: 'Usuario',
        acao: 'view',
      },
      {
        icon: 'fa-pen-nib',
        path: { name: 'TextosEditaveisIndex' },
        title: 'Textos do sistema',
        exact: false,
        entidade: 'TextoEditavel',
        acao: 'view',
      },
    ],
    menuPaciente: [
      {
        icon: 'fa-laptop-medical',
        path: { name: 'MedicoesIndex' },
        title: 'Medições',
        exact: true,
        entidade: 'MedicaoGlicemia',
        acao: 'view_index',
      },
    ],
  }),
  computed: {
    usuarioLogado(): boolean {
      return this.usuario && this.usuario.token;
    },
    usuarioPaciente() : boolean {
      return this.usuarioLogado && this.usuario.grupo.alias === 'pacientes';
    },
    menu(): { icon: string, title: string, path: { name: string } }[] {
      if (this.usuarioLogado) {
        if (this.usuarioPaciente) {
          return this.menuPaciente;
        }
        return this.menuLogado;
      }
      return this.menuDeslogado;
    },
  },
});
